import React, { Component } from 'react';

import './Filter.css';

import Checkbox from './Checkbox.js';


class Filter extends Component {

  constructor(props){
    super(props);
    // console.log('| - - | - - | - - | - - | - - | - - | - - | - - |');
    // console.log('filterValues: ', this.props.filterValues);

    this.value = (this.props.value) ? this.props.value : "";
    this.type = (this.props.type) ? this.props.type : 'text';
    this.checked = (this.props.checked) ? this.props.checked : false;
    this.showFilter = (this.props.showFilter) ? this.props.showFilter : false;

    this.prevStrId = 'filter-checkbox-';

    this.state = ({
      filterIsActive:this.props.isActive
    })

    // Object.keys(this.props.filterValues).map((value,key) => {
    //   let checked = this.props.filterValues[value];
    //   if(checked){
    //     this.setState({
    //       filterIsActive:true
    //     })
    //   }
    // });

    this.handleChange = this.handleChange.bind(this);
    this.cleanFilter = this.cleanFilter.bind(this);
    this.getOptions = this.getOptions.bind(this);
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   console.log('nextProps: ', nextProps);
  //   console.log('nextProps: ', nextProps.filterValues);
  //   console.log('nextProps: ', this.props.filterValues);
  //   // if(Object.is(nextProps.filterValues,this.props.filterValues)){
  //   //   return false;
  //   // }
  //   return true;
  // }
  //
  componentWillUpdate(props, state){

      let checkedVal = false;

      Object.keys(props.filterValues).map((value,key) => {
        let checked = props.filterValues[value];
        if(checked){
          checkedVal = checked ;
        }
        if(checked && !state.filterIsActive){
          this.setState({
            filterIsActive:true
          })
        }
      });

      if(!checkedVal && state.filterIsActive){
        this.setState({
          filterIsActive:false
        })
      }


  }
  handleChange(id, val){

    let filterValId = id.replace(this.prevStrId, '');
    this.props.onChange(this.props.title, filterValId, val);
  }

  cleanFilter(){
    Object.keys(this.props.filterValues).map((value,key) => {
      this.handleChange(value, false);
    })
  }
  getOptions(){
    if(this.props.options){
      return (
        <div className="flex-row filter__options">
          <div onClick={this.cleanFilter} className={ this.state.filterIsActive ? "btn--small" : "hidden" }>Rensa</div>
        </div>
      )
    }
  }

  render() {

    let _classes = this.state.filterIsActive ? "filter__list" : "filter__list filter__list--inactive";

    return (

      <div className={_classes}>
        <div className="filter__list__header">
          <h3>{this.props.title}</h3>
        </div>

        {
          Object.keys(this.props.filterValues).map((value,key) => {
            let checked = this.props.filterValues[value];
            return (
              <Checkbox key={this.prevStrId +value} id={this.prevStrId + value} checked={checked} label={value} onChange={this.handleChange} />
            )
          })


        }

        {this.getOptions()}

      </div>

    )
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/Filter.js